import { useState } from 'react'
import { router } from '@inertiajs/react'
import ConfirmModal from '../shared/ConfirmModal'

interface Props {
  onClose: () => void
}

export default function AddGuideModal({ onClose }: Props) {
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [confirmExisting, setConfirmExisting] = useState<string | null>(null)

  const post = (confirm: boolean) => {
    setSubmitting(true)
    router.post('/people/add_guide', {
      email,
      confirm_existing: confirm ? '1' : null,
    }, {
      onFinish: () => setSubmitting(false),
      onSuccess: () => onClose(),
      onError: (errs) => {
        if (errs.confirm_existing) setConfirmExisting(errs.confirm_existing as string)
      },
    })
  }

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    post(false)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-elevated w-full max-w-md mx-4">
        <div className="px-6 py-4 border-b border-stone/20 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-text-primary font-heading">Add a Guide</h2>
          <button onClick={onClose} className="text-text-muted hover:text-text-primary transition-colors">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <form onSubmit={submit} className="p-6 space-y-4">
          <p className="text-sm text-text-muted">
            Enter the email of an existing Guide to add them to this organization.
            Guides are created by a Pinnacle administrator.
          </p>
          <div>
            <label className="block text-sm font-medium text-text-primary mb-1.5">Guide email</label>
            <input
              type="email"
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="guide@example.com"
              className="w-full border border-stone/30 rounded-lg px-3 py-2 text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-charcoal/40 focus:border-charcoal"
            />
          </div>

          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-text-primary">Cancel</button>
            <button
              type="submit"
              disabled={submitting || !email.trim()}
              className="px-5 py-2 bg-pinnacle-red text-white text-sm font-semibold rounded-lg hover:bg-pinnacle-red/90 disabled:opacity-50"
            >
              {submitting ? 'Adding...' : 'Add Guide'}
            </button>
          </div>
        </form>
      </div>

      <ConfirmModal
        isOpen={confirmExisting !== null}
        title="Add existing Pinnacle Navigator user?"
        message={confirmExisting || ''}
        confirmLabel="Yes, add them"
        variant="warning"
        submitting={submitting}
        onConfirm={() => {
          setConfirmExisting(null)
          post(true)
        }}
        onClose={() => setConfirmExisting(null)}
      />
    </div>
  )
}
